module.exports = new __parcel__URL__("pack_item_veil.818b2ef2.png").toString();